import React from 'react'
import { Footer } from 'antd/es/layout/layout'
import { Button, Col, Row } from 'antd'
import '../asset/less/Footer.css'
import { FacebookOutlined, InstagramOutlined, LinkedinOutlined } from '@ant-design/icons'

export default (props) => {
  return (
    <Footer
      style={{
        textAlign: 'center',
        marginTop: 160,
        marginBottom: 24,
        borderTop: '1px solid rgba(0, 0, 0, 0.12)',
        paddingTop: 48,
        paddingBottom: 48,
        marginLeft: 15,
        marginRight: 15
      }}
    >
      <Row>
        <Col style={{ marginTop: 12 }} xs={24} sm={24} md={8}>
          <Row align='middle' gutter={{ xs: 8, sm: 16, md: 24 }}>
            <Col style={{marginLeft: 'auto'}}>
              <Button type='text' href={'https://www.facebook.com/revart.co'} target='_blank'>
                <FacebookOutlined style={{ fontSize: 32 }} />
              </Button>
            </Col>
            <Col>
              <Button type='text' href={'https://www.instagram.com/revart_global'} target='_blank'>
                <InstagramOutlined style={{ fontSize: 32 }} />
              </Button>
            </Col>
            <Col style={{marginRight: 'auto'}}>
              <Button type='text' href={'https://www.linkedin.com/company/revartco'} target='_blank'>
                <LinkedinOutlined style={{ fontSize: 32 }} />
              </Button>
            </Col>
            <Col>
              <p style={{ fontSize: 18, marginTop: 32 }}>
                Copyright 2023 <span style={{ color: '#34dbc5' }}>RevArt</span> . All Rights Reserved.
              </p>
            </Col>
          </Row>
        </Col>
        <Col xs={24} sm={24} md={16}>
          <Row align='middle' gutter={{ xs: 96, sm: 32, md: 48 }}>
            <Col className='gutter-row' xs={12} sm={8} style={{marginTop: 12}}>
              <span style={{ fontSize: 18, width: '100%' }}>Main Navigation</span>
              <a className={'a-link'} href={'https://revart.co'} target='_blank' rel='noreferrer'>
                Home
              </a>
              <a className={'a-link'} href={'https://revart.co/exhibitions'} target='_blank' rel='noreferrer'>
                Upcoming exhibitions
              </a>
              <a className={'a-link'} href={'https://revart.co/brands'} target='_blank' rel='noreferrer'>
                Brand Partnership
              </a>
              <a className={'a-link'} href={'https://revart.co/artists-program/'} target='_blank' rel='noreferrer'>
                Artist Program
              </a>
            </Col >
            <Col className='gutter-row' xs={12} sm={8} style={{marginTop: 12}}>
              <span style={{ fontSize: 18 }}>About Us</span>
              <a className={'a-link'} href={'https://revart.co/about-us/#team'} target='_blank' rel='noreferrer'>
                Team
              </a>
              <a className={'a-link'} href={'mailto: contact@revart.co'} target='_blank' rel='noreferrer'>
                Support
              </a>
              <a className={'a-link'} href={'https://revart.co/webstatic/assets/demo/intro/revart_brochure.pdf'} target='_blank' rel='noreferrer'>
                Company Introduction
              </a>
              <a className={'a-link'} href={'https://revart.co/contact-us/'} target='_blank' rel='noreferrer'>
                Contact Us
              </a>
            </Col>
            <Col className='gutter-row' xs={12} sm={8} style={{marginTop: 12}}>
              <span style={{ fontSize: 18 }}>Resources</span>
              <a className={'a-link'} href={'https://revart.co/blogs/'} target='_blank' rel='noreferrer'>
                Blogs
              </a>
              <a className={'a-link'} href={'https://revart.co/sam/faq/'} target='_blank' rel='noreferrer'>
                FAQ
              </a>
              <a className={'a-link'} href={'https://revart.co/privacy/'} target='_blank' rel='noreferrer'>
                Privacy
              </a>
              <a className={'a-link'} href={'https://revart.co/terms-of-use/'} target='_blank' rel='noreferrer'>
                Terms of Use
              </a>
            </Col>
          </Row>
        </Col>
      </Row>
    </Footer>
  )
}
